var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import * as API from './api';
import * as UserSrv from './user-service';
let Challenge = class Challenge extends Vue {
    constructor() {
        super(...arguments);
        this.is_admin = UserSrv.is_admin();
        this.challenge = null;
    }
    fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            let challenge_uid = parseInt(this.$route.params['challenge_uid']);
            let challenge = yield API.getChallenge(challenge_uid);
            if (challenge !== 'Error') {
                this.challenge = challenge;
            }
        });
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchData();
            hljs.highlightBlock(this.$refs['code']);
        });
    }
    getResult(state, result) {
        return API.getResult(state, result);
    }
    onRejudge() {
        if (this.challenge !== null) {
            API.rejudgeSingleChallenge(this.challenge.uid).then((ret) => {
                // console.log('Rejudge', ret)
                this.$router.go(0);
            });
        }
    }
};
__decorate([
    Watch('$route'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Challenge.prototype, "fetchData", null);
Challenge = __decorate([
    Component
], Challenge);
export default Challenge;



// WEBPACK FOOTER //
// ./src/Challenge.vue